// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";
import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../utils/createApi";
import { getRefreshToken } from "../../../utils/getRefreshToken";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { SiteOptions } from "../../Analytics/AnalyticsUtils/analyticsInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const getSitesByParentGroupAlerts = (
  id: string,
  navigate: NavigateFunction,
  setSiteOptions: Dispatcher<SiteOptions[]>,
  setLoadingSites: Dispatcher<boolean>
) => {
  setLoadingSites(true);
  const AxiosUI = createApi("");
  const retryFunction = () => {
    getSitesByParentGroupAlerts(id, navigate, setSiteOptions, setLoadingSites);
  };

  AxiosUI.get(`customer/names/${id}/`).then(
    (response: AxiosResponse) => {
      const sites = Array.isArray(response.data)
        ? response.data
        : response.data?.results ?? [];
      setSiteOptions(sites);
      setLoadingSites(false);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        alert("Error retrieving sites. Please try again");
        setLoadingSites(false);
      });
    }
  );
};
